import { RootState } from '@reducers';

export const selectPasswordPage = (state: RootState) => state.userDashboardRouteReducer.passwordPageReducer;
